import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { CheckCircle2, XCircle, Loader2 } from 'lucide-react';
import { payments } from '../lib/api';
import XpertLogo from '../components/XpertLogo';

export default function PaymentReturn() {
  const [state, setState] = useState('checking'); // checking | success | failed | timeout
  const [info, setInfo] = useState(null);

  useEffect(() => {
    const sid = new URLSearchParams(window.location.search).get('session_id');
    if (!sid) { setState('failed'); return; }
    let attempts = 0;
    const poll = async () => {
      attempts += 1;
      try {
        const d = await payments.publicStatus(sid);
        setInfo(d);
        if (d.payment_status === 'paid') { setState('success'); return; }
        if (d.status === 'expired') { setState('failed'); return; }
      } catch { /* retry */ }
      if (attempts >= 6) { setState('timeout'); return; }
      setTimeout(poll, 2000);
    };
    poll();
  }, []);

  return (
    <div className="min-h-screen bg-[#0d2818] flex items-center justify-center p-4">
      <div className="bg-white rounded-2xl max-w-md w-full p-8 text-center" data-testid="payment-return">
        <div className="flex justify-center mb-4"><XpertLogo size={48} /></div>
        {state === 'checking' && (<><Loader2 className="w-12 h-12 mx-auto text-[#8BC53F] animate-spin" /><h1 className="text-xl font-extrabold text-slate-900 mt-4">Confirming your payment…</h1><p className="text-slate-500 text-sm mt-2">This only takes a moment.</p></>)}
        {state === 'success' && (<><CheckCircle2 className="w-14 h-14 mx-auto text-emerald-500" /><h1 className="text-2xl font-extrabold text-slate-900 mt-4" data-testid="payment-success">Payment Successful!</h1><p className="text-slate-500 text-sm mt-2">Thank you. Your invoice has been marked as paid{info?.amount_total ? ` (${(info.amount_total / 100).toLocaleString('en-US', { style: 'currency', currency: (info.currency || 'usd').toUpperCase() })})` : ''}.</p></>)}
        {(state === 'failed' || state === 'timeout') && (<><XCircle className="w-14 h-14 mx-auto text-red-500" /><h1 className="text-xl font-extrabold text-slate-900 mt-4">{state === 'timeout' ? 'Still processing' : 'Payment not completed'}</h1><p className="text-slate-500 text-sm mt-2">{state === 'timeout' ? 'Your payment is taking longer than expected. Check your invoices shortly.' : 'No charge was made. You can try again from your invoices.'}</p></>)}
        <Link to="/portal/invoices" className="inline-block mt-6 px-6 py-2.5 rounded-lg bg-[#8BC53F] hover:bg-[#6FA82C] text-white font-semibold transition" data-testid="back-to-invoices">Back to Invoices</Link>
      </div>
    </div>
  );
}
